/** A card made in the last few seconds arrives with an entrance; one that was already there does not. */
export const FRESH_MS = 5000

export const isFresh = (createdAt: string | undefined, now: number, ms = FRESH_MS) => {
  const t = createdAt ? Date.parse(createdAt) : NaN
  return Number.isFinite(t) && now - t >= -ms && now - t < ms
}
